import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Footer, FooterContent } from '../_model/footer';
import { GuidedHelp } from '../_model/guidedhelp';
import { HelpTopics } from '../_model/helptopics';
import { HomeService } from '../_services/home.service';
import { AuthenticationService } from '../_services/index';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';
@Component({
selector: 'app-kb-articles',
templateUrl: './kb-articles.component.html',
styleUrls: ['./kb-articles.component.scss']
})
export class KbArticlesComponent implements OnInit {
pk: number;
topics: HelpTopics;
helpTopics: GuidedHelp = {};
status: any;
name: String;
names: any;
topArticles: any;
article: any;
childPk: any;
parent: any;
child: any;
searchPk: any;
topArticleTitle: any;
searchdata: any[];
selectedValue: any;
keyword = 'name';
data = [];
caseAlertMessage: string;
alert: boolean=false;
delayed: boolean = false ;
searchBanner: any;
searchTextboxNote: any;
searchTextboxHover: any;
searchButtonHover: any;
searchKey: any;
kb: any = [];
articleView: any;

constructor(private activatedRoute: ActivatedRoute,
  private homeService: HomeService,
  private authenticationService: AuthenticationService,
  private gaService : GoogleAnalyticsService,
  private router: Router) {
this.activatedRoute.queryParams.subscribe(params => {
this.pk = params['PK'];
this.childPk = params['childPk'];
this.searchPk=params['searchPk']
this.getChildren();

});
}

ngOnInit() {
this.kbSearchConfig();
this.gaService.updatePageName();
this.getTopArticles();
this.getArticle()
this.getHelpTopics();
this.getTopArticleTitle();
this.caseMessage();
}

kbSearchConfig(){
  this.homeService.getKbSearchConfiguration().subscribe(res => {
    this.searchBanner = res.return_body.searchBanner;
    this.searchTextboxNote = res.return_body.searchTextboxNote;
    this.searchTextboxHover = res.return_body.searchTextboxHoverNote;
    this.searchButtonHover = res.return_body.searchButtonHoverNote;
  });
}

getChildren() {
  let totalTopics = [];
this.homeService.getChildren(this.pk).subscribe(res => {
this.topics = res;
this.articleView = res.return_body[0].kbData.items;
for (let i = 0; i < 5; i++) {
  totalTopics = this.articleView[i];
  this.kb = this.kb.concat(totalTopics);
}
this.names= res.return_body;
this.getHelpTopics();
for(var val of this.names){
if(val.pk==this.searchPk){
  this.name= val.stepName
  this.status=val.kbData
}
}
});
}
getArticle() {
this.homeService.getChildren(this.childPk).subscribe(res => {
this.names= res.return_body;
for(var val of this.names){
  if(val.pk==this.pk){
    this.parent= val.stepName
  }
}
});
}
getHelpTopics() {
this.homeService.getHelpTopics().subscribe(res => {
this.names= res.return_body;
this.helpTopics = res;
this.names=res.return_body
for(var val of this.names){
if(val.pk==this.childPk){
this.child= val.stepName
}
}
});
}
getTopArticles() {    
  this.homeService.getTopArticles().subscribe(res => {
  this.topArticles = res.return_body;
});
}
getTopArticleTitle() {
  this.homeService.getTopArticleTitle().subscribe(res =>{
    this.topArticleTitle = res.return_body.title;
  })
}
handleNavigation(pathValue) {
if (pathValue) {
  this.router.navigate([this.router.url.split("/")[1], pathValue]);
}
}
navigate(pk) {
this.router.navigate(['/' + this.router.url.split('/')[1] + '/helptopics'], { queryParams: { PK: pk,childPk:this.childPk }});
}
navigateToSearch(pk) {
this.router.navigate(['/' + this.router.url.split('/')[1] + '/search'], { queryParams: { pk:this.pk,parentPk:this.childPk }});
}
selectEvent(item) {
  this.selectedValue = item.name;
  this.search(this.selectedValue);
}

onChangeSearch(val: string) {
  this.selectedValue = val;
  this.data = [];
  if (val != '') {
    this.homeService.getSearchData(val).subscribe(res => {
      this.data = [];
      res.return_body.map((response, index) => {
        this.data.push({ id: index, name: response });
      })
    });
  }
}

onFocused(e) {
  this.data = [];
}

search(selectedValue){
  this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { selectedValue: selectedValue, currentPage: 0 }});
}
onKeyEnterSearch(event: any, searchkeyWrd: any) {
  this.search(searchkeyWrd);
}

searchCleared(){
  this.selectedValue = '';
}

// ngAfterViewInit() {
//   this.caseMessage();
// }
caseMessage(){
    this.caseAlertMessage= sessionStorage.getItem('alertMessage')
    if(this.caseAlertMessage){
      this.alert=true
    }
    setInterval(() => {
     this.delayed=true
     this.alert=false
     sessionStorage.removeItem('alertMessage')
    }, 5000);
  }

}
